module.exports = __webpack_public_path__ + "img/logo-wise.2723c8e8.svg";